import React from 'react';
import styles from './article-content-sections.module.scss';

interface ContentSection {
  title: string;
  content: string;
  notes?: string;
  subcontent?: {
    title: string;
    content: string;
  }[];
}

interface ArticleContentSectionsProps {
  contentArray: ContentSection[];
  className?: string;
}

const ArticleContentSections: React.FC<ArticleContentSectionsProps> = ({ contentArray, className }) => {
  const classes = `${styles.contentArray} ${className || ''}`.trim();

  return (
    <div className={classes}>
      {contentArray.map((section, index) => (
        <div key={index} className={styles.section} id={`section-${index}`}>
          <h3 className={styles.sectionTitle}>{section.title}</h3>
          <div 
            className={styles.sectionContent}
            dangerouslySetInnerHTML={{ __html: section.content }}
          />
          {section.subcontent && section.subcontent.length > 0 && (
            <div className={styles.subcontent}>
              {section.subcontent.map((sub, subIndex) => (
                <div key={subIndex} className={styles.subsection} id={`subsection-${index}-${subIndex}`}>
                  <h4 className={styles.subsectionTitle}>{sub.title}</h4>
                  <div 
                    className={styles.subsectionContent}
                    dangerouslySetInnerHTML={{ __html: sub.content }}
                  />
                </div>
              ))}
            </div>
          )}
          {section.notes && (
              <div 
                className={styles.note}
                dangerouslySetInnerHTML={{ __html: section.notes }}
              />
          )}
        </div>
      ))}
    </div>
  );
};

export default ArticleContentSections; 